module.exports = __webpack_public_path__ + "b11c022312df0db5b350c2b70713934a.png";